import { faUser, faUsers } from '@fortawesome/pro-solid-svg-icons';
import PropTypes from 'prop-types';

import { Icon } from 'Icons';
import { FAIcon } from 'lib/customPropTypes';

const avatarContainer =
  'bg-gray-2 rounded-full text-gray-5 inline-flex justify-center items-center overflow-hidden text-center';

const fontSize = {
  small: 'text-sm',
  default: 'text-base',
  large: 'text-xl',
  xlarge: 'text-2xl',
};

const heightWidth = {
  small: 'h-4 w-4',
  default: 'h-6 w-6',
  large: 'h-8 w-8',
  xlarge: 'h-10 w-10',
};

const Avatar = ({ icon, imgAltText, imgSrc, size, ...rest }) => {
  let avatar = (
    <Icon alt={imgAltText} icon={icon} transform="shrink-2" {...rest} />
  );

  if (imgSrc) {
    avatar = (
      <img
        alt={imgAltText}
        className={`align-middle ${heightWidth[size]}`}
        src={imgSrc}
        {...rest}
      />
    );
  }

  return (
    <div
      className={`${avatarContainer} ${heightWidth[size]} ${fontSize[size]}`}
    >
      {avatar}
    </div>
  );
};

Avatar.defaultProps = {
  icon: faUser,
  imgAltText: '',
  imgSrc: undefined,
  size: 'default',
};

Avatar.propTypes = {
  icon: FAIcon,
  imgAltText: PropTypes.string,
  imgSrc: PropTypes.string,
  size: PropTypes.oneOf(['small', 'default', 'large', 'xlarge']),
};

// Team variant
// TODO: no need for a unique React component, should be deprecated in favor of <Avatar />

const AvatarTeam = ({ ...props }) => <Avatar {...props} />;

AvatarTeam.defaultProps = {
  icon: faUsers,
};

export default Avatar;
export { AvatarTeam };
